import AllOvertime from "../overtime/views/AllOvertime.vue";
import settings from "../overtime/views/settings.vue";
import WorkRateSettings from "../overtime/views/WorkRateSettings";
import OvertimeRulesSettings from "../overtime/views/OvertimeRules";
import WorkRateForm from "../overtime/views/WorkRateForm";
import WorkRateSettingsView from "../overtime/views/WorkRateSettingsView";
import OvertimeRulesForm from "../overtime/views/OvertimeRulesForm";
import ApproverForm from "../overtime/views/ApproverForm";
import ApproverSettings from "../overtime/views/ApproverSettings";
import AssignEmployeeWorkRate from "../overtime/views/AssignEmployeeWorkRate";
import AssignEmployeeOvertimeRule from "../overtime/views/AssignEmployeeOvertimeRule";
import AssignEmployeeApprover from "../overtime/views/AssignEmployeeApprover";
import OvertimeRuleSettingsView from "../overtime/views/OvertimeRuleSettingsView";
import ApproverSettingsView from "../overtime/views/ApproverSettingsView";
export default [
  {
    path: "all",
    component: AllOvertime,
  },
  {
    path: "settings",
    component: settings,
  },
  {
    path: "settings/work-rate",
    component: WorkRateSettings,
  },
  {
    path: "settings/overtime-rules",
    component: OvertimeRulesSettings,
  },
  {
    path: "settings/work-rate/create",
    component: WorkRateForm,
  },
  {
    path: "settings/work-rate/edit/:id",
    component: WorkRateForm,
  },
  {
    name: "assign-employee-workrate",
    path: "settings/work-rate/assign-employee/:id",
    component: AssignEmployeeWorkRate,
  },
  {
    name: "view-workRate-settings",
    path: "settings/work-rate/view/:id",
    component: WorkRateSettingsView,
  },
  {
    path: "settings/overtime-rule/create",
    component: OvertimeRulesForm,
  },
  {
    path: "settings/overtime-rule/edit/:id",
    component: OvertimeRulesForm,
  },
  {
    name: "view-overtime-rule-settings",
    path: "settings/overtime-rule/view",
    component: OvertimeRuleSettingsView,
  },
  {
    name: "assign-employee-overtime-rule",
    path: "settings/overtime-rule/assign-employee/:id",
    component: AssignEmployeeOvertimeRule,
  },
  {
    path: "settings/approver",
    component: ApproverSettings,
  },
  {
    path: "settings/approver/create",
    component: ApproverForm,
  },
  {
    path: "settings/approver/edit/:id",
    component: ApproverForm,
  },
  {
    name: "view-approver-settings",
    path: "settings/approver/view",
    component: ApproverSettingsView,
  },
  {
    name: "assign-employee-approver",
    path: "settings/approver/assign-employee/:id",
    component: AssignEmployeeApprover,
  },
];
